import React from 'react';
import ChooseAppartment from './ChooseAppartment';
import ButtonVideo from './ButtonVideo';
import Text from '../../commons/Text'

const IndexView = ({ scrollWebsite }) => (
    <div className="App360">
        <div className="mainPage">
            <div className="title">
                <h1><Text Key="360_title" /></h1>
                <h2><Text Key="360_subtitle" /></h2>
            </div>
            <div className="bottomItems">
                <ChooseAppartment />
                <div className="form">
                    <img src="kozySlider/images/fleche-bottom.png" alt="arrow down" className="arrowDown" onClick={scrollWebsite} />
                </div>
            </div>
            <ButtonVideo />
        </div>
    </div>
)

export default IndexView;



// WEBPACK FOOTER //
// ./src/components/360Mode/IndexView/IndexView.js